import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EDITORES_EM_CAMADA } from '@/app/editores-em-camada';
import { DetalheDoAtendimento } from '@/features/atendimentos/componentes/DetalheDoAtendimento';
import { rotaDeTela } from '@/features/permissoes/guardas';

const busca = z.object({ editar: z.boolean().optional().catch(undefined) });

/** Detalhe e edição do atendimento (spec 010, CA-07, CA-09, CA-10). */
export const Route = createFileRoute('/_autenticado/atendimentos/$id')({
  ...rotaDeTela('atendimentos.lista'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const { id } = Route.useParams();
  const { editar } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DetalheDoAtendimento
      key={id}
      id={id}
      editando={editar === true}
      editores={EDITORES_EM_CAMADA}
      aoEditar={(editando) => {
        void navigate({ search: { editar: editando || undefined } });
      }}
      aoExcluir={() => {
        void navigate({ to: '/atendimentos' });
      }}
    />
  );
}
